<script lang="ts">
  import Form from "../components/Form.svelte";
  import RadioGroup from "../components/RadioGroup.svelte";
  import Car from "~icons/ph/car-profile-fill";
  import Info from "~icons/ph/info";
  import { domId } from "../lib/dom";

  let {
    initial_values, end_reason_options, action, errors, check_trade_in_url
  } : {
    initial_values : { [key: string]: string | null };
    end_reason_options : Array<{label: string, value: string, date_label: string | false}>;
    action : string;
    errors : { [key: string]: string } | null;
    check_trade_in_url? : string;
  } = $props()

  let selectedReason = $state(initial_values.end_reason || null)
  let dateLabel = $derived.by(()=>{
    for(const option of end_reason_options) {
      if(option.value == selectedReason) return option.date_label;
    }
    return false;
  })

  const endDateId = domId("end-date")
  const closeDialogId = domId("close-dialog")
</script>

{#if !check_trade_in_url}
  <Form method="put" {action} class="ui-rhythm">
    <h2 class="ui-title">Agreement end date</h2>

    <fieldset class="ui-fieldset">
      <legend>When did your agreement end?</legend>
      <RadioGroup
        name="end_reason"
        options={end_reason_options.map((option) => [option.label, option.value])}
        bind:group={selectedReason}
        required
      />
      {#if errors?.end_reason}<div class="ui-error">{errors.end_reason}</div>{/if}
    </fieldset>

    <fieldset class="ui-fieldset mt-6" class:invisible={!dateLabel}>
      <legend>{dateLabel}</legend>
      <input id={endDateId} type="date" name="end_date" class="ui-input" class:input-error={errors?.end_date} disabled={!dateLabel} required={!!dateLabel} value={initial_values.end_date || ""}>

      <div class="ui-alert ui-alert-info my-4">
        <Info />
        <p>If you are unsure of the date, just get as close as you can. Even the correct year helps.</p>
      </div>

      {#if errors?.end_date}<div class="ui-error">{errors.end_date}</div>{/if}
    </fieldset>

    {#if errors?.general}<div class="ui-error">{errors.general}</div>{/if}

    <div class="floating-footer">
      <button class="btn btn-ghost" form={closeDialogId}>Cancel</button>
      <button class="btn btn-primary" type="submit">Done</button>
    </div>
  </Form>

{:else}
  <div class="ui-alert ui-alert-info mt-0 mb-4">
    <Car />
    <p>
      {#if selectedReason == "trade-in"}
        Your new vehicle purchase
      {:else}
        Your subsequent vehicle purchase
      {/if}
      may also be eligible for a PCP claim.
    </p>
  </div>

  <div class="floating-footer">
    <button class="btn btn-ghost" form={closeDialogId}>Close</button>
    <a href={check_trade_in_url} class="btn btn-primary hover:text-white active:text-white visited:text-white" target="_blank" rel="noopener">Check Eligibility</a>
  </div>
{/if}

<form method="dialog" id={closeDialogId}></form>
